/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenMonitorIcon64Regular = forwardRef('TechScreenMonitorIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 7C10.701 7 6 11.701 6 17.5v20C6 43.299 10.701 48 16.5 48H24v7h-6.5a1.5 1.5 0 0 0 0 3h29a1.5 1.5 0 0 0 0-3H40v-7h7.5C53.299 48 58 43.299 58 37.5v-20C58 11.701 53.299 7 47.5 7h-31Zm31 38a7.5 7.5 0 0 0 7.5-7.5v-20a7.5 7.5 0 0 0-7.5-7.5h-31A7.5 7.5 0 0 0 9 17.5v20a7.5 7.5 0 0 0 7.5 7.5h31ZM37 48v7H27v-7h10Z" })));
});
